import React from 'react';
import { ContentList } from './types';

const ContentContext = React.createContext<ContentList | undefined>(undefined);

export default ContentContext;
